import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-back-hardware-button',
  templateUrl: './back-hardware-button.component.html',
  styleUrls: ['./back-hardware-button.component.css']
})
export class BackHardwareButtonComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  public back() {
    this.location.back();
  }

}
